module.exports = __webpack_public_path__ + "static/icon-rotate-device@3x-3dcd748ccbc118b525b3751dc3f171ca.png";